
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessibility",
      function () {
        return require("private-next-pages/accessibility/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accessibility"])
      });
    }
  